import { PageEvent } from '@angular/material/paginator';
import { ParamMap } from '@angular/router';
import * as moment from 'moment';

export class Params {

  start: string;
  end: string;
  methods: string;
  brands: string;
  services: string;
  statuses: string;
  installments: string;
  minAmount: string;
  maxAmount: string;
  page: number;
  pageSize: number;
  fileExtension: string;
  dateSort: string;
  searchType: string;
  searchTerm: string;
  flows: string;
  partnerUniqueId: string;
  authorizerNsu: string;
  captureNsu: string;
  authorizerTransactionId: string;

  constructor(params: ParamMap) {
    this.start = params.get('start')?.replace(/(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/g, '$1-$2-$3 $4:$5:$6');
    this.end = params.get('end')?.replace(/(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/g, '$1-$2-$3 $4:$5:$6');
    this.methods = params.get('methods');
    this.flows = params.get('flows');
    this.brands = params.get('brands');
    this.services = params.get('services');
    this.statuses = params.get('statuses');
    this.installments = params.get('installments');
    this.minAmount = params.get('min_amount');
    this.maxAmount = params.get('max_amount');
    this.page = params.get('page') ? +params.get('page') : 1;
    this.pageSize = params.get('page_size') ? +params.get('page_size') : 20;
    this.dateSort = params.get('date_sort') ?? 'desc';
    this.searchType = params.get('search_type');
    this.searchTerm = params.get('search_term');
    this.partnerUniqueId = params.get('partner_unique_id');
    this.authorizerNsu = params.get('authorizer_nsu');
    this.captureNsu = params.get('capture_nsu');
    this.authorizerTransactionId = params.get('authorizer_transaction_id');
  }

  setPeriod(period: any) {

    if (moment(period.end).startOf('day').valueOf() == moment(period.end).valueOf()) {
      period.end = moment(period.end).endOf('day');
    }

    this.start = moment(period.start).format('YYYY-MM-DD HH:mm:ss');
    this.end = moment(period.end).format('YYYY-MM-DD HH:mm:ss');

  }

  setFilter(filter: any) {
    this.methods = this.arrayToString(filter.methodTypes);
    this.brands = this.arrayToString(filter.cardBrands);
    this.services = this.arrayToString(filter.services);
    this.statuses = this.arrayToString(filter.statuses);
    this.installments = this.arrayToString(filter.installments);
    this.minAmount = filter.amountRange ? filter.amountRange[0] : null;
    this.maxAmount = filter.amountRange ? filter.amountRange[1] : null;
    this.partnerUniqueId = filter.partnerUniqueID;
    this.authorizerNsu = filter.authorizerNsu;
    this.captureNsu = filter.captureNsu;
    this.authorizerTransactionId = filter.authorizerTransactionID;
    this.flows = this.arrayToString(filter.flows);
    this.searchTerm = filter.search_term;
    this.searchType = filter.search_type;

    if (this.minAmount && this.maxAmount && this.searchType === 'amount') {
      if (this.minAmount === this.maxAmount) {
        this.searchTerm = this.maxAmount;
        this.minAmount = null;
        this.maxAmount = null;
      } else {
        this.searchTerm = null;
        this.searchType = null;
      }
    }
  }

  resetFilter() {
    this.start = null;
    this.end = null;
    this.methods = null;
    this.brands = null;
    this.services = null;
    this.statuses = null;
    this.installments = null;
    this.minAmount = null;
    this.maxAmount = null;
    this.searchType = null;
    this.searchTerm = null;
    this.partnerUniqueId = null;
    this.authorizerNsu = null;
    this.captureNsu = null;
    this.authorizerTransactionId = null;
    this.flows = null;
  }

  setSearch(search: any) {
    this.setLastSearch();
    this.searchType = search[0];
    this.searchTerm = search[1];
  }

  setLastSearch() {
    switch (this.searchType) {
      case 'partner_unique_id':
        this.partnerUniqueId = this.searchTerm;
        break;
      case 'authorizer_transaction_id':
        this.authorizerTransactionId = this.searchTerm;
        break;
      case 'authorizer_nsu':
        this.authorizerNsu = this.searchTerm;
        break;
      case 'capture_nsu':
        this.captureNsu = this.searchTerm;
        break;
    }
  }

  resetSearch() {
    this.searchType = null;
    this.searchTerm = null;
  }

  setPagination(event: PageEvent) {
    this.page = event.pageIndex + 1;
    this.pageSize = event.pageSize;
  }

  resetPage() {
    this.page = 1;
  }

  getSelectedFilters() {
    return {
      date: {
        name: 'date',
        value: [this.start, this.end],
        type: ['start', 'end']
      },
      method_types: {
        name: 'method_types',
        value: this.methods,
        type: 'methods'
      },
      card_brands: {
        name: 'card_brands',
        value: this.brands,
        type: 'brands'
      },
      services: {
        name: 'services',
        value: this.services,
        type: 'services'
      },
      statuses: {
        name: 'statuses',
        value: this.statuses,
        type: 'statuses'

      },
      installments: {
        name: 'installments',
        value: this.installments,
        type: 'installments'
      },
      amount: {
        name: 'amount',
        value: [this.minAmount, this.maxAmount],
        type: ['minAmount', 'maxAmount']
      },
      search: {
        name: this.searchType,
        value: this.searchTerm,
        type: ['searchType', 'searchTerm']
      },
      partner_unique_id: {
        name: 'partner_unique_id',
        value: this.partnerUniqueId,
        type: 'partnerUniqueId'
      },
      authorizer_transaction_id: {
        name: 'authorizer_transaction_id',
        value: this.authorizerTransactionId,
        type: 'authorizerTransactionId'
      },
      authorizer_nsu: {
        name: 'authorizer_nsu',
        value: this.authorizerNsu,
        type: 'authorizerNsu'
      },
      capture_nsu: {
        name: 'capture_nsu',
        value: this.captureNsu,
        type: 'captureNsu'
      },
      flows: {
        name: 'flows',
        value: this.flows,
        type: 'flows'
      }
    };
  }

  createQueryParams() {
    return {
      start: this.start?.replace(/ /g, '').replace(/[-]/g, '').replace(/[:]/g, ''),
      end: this.end?.replace(/ /g, '').replace(/[-]/g, '').replace(/[:]/g, ''),
      methods: this.methods,
      brands: this.brands,
      services: this.services,
      statuses: this.statuses,
      installments: this.installments,
      min_amount: this.minAmount,
      max_amount: this.maxAmount,
      page: this.page,
      page_size: this.pageSize,
      date_sort: this.dateSort,
      search_type: this.searchType,
      search_term: this.searchTerm,
      flows: this.flows,
      partner_unique_id: this.partnerUniqueId,
      authorizer_nsu: this.authorizerNsu,
      capture_nsu: this.captureNsu,
      authorizer_transaction_id: this.authorizerTransactionId
    };
  }

  createPost() {
    return {
      start_date: this.start ?? moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
      end_date: this.end ?? moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
      payment_method_type_ids: this.stringToArray(this.methods),
      card_brand_ids: this.stringToArray(this.brands),
      service_ids: this.stringToArray(this.services),
      payment_status_ids: this.stringToArray(this.statuses),
      installments: this.stringToArray(this.installments).length == 0 || this.stringToArray(this.installments).length == 2 ? null : this.installments == '1' ? true : false,
      min_amount: this.minAmount,
      max_amount: this.maxAmount,
      page: this.page,
      page_size: this.pageSize,
      date_sort_asc: this.dateSort === 'asc',
      search_type: this.searchType,
      search_term: this.searchTerm,
      partner_unique_id: this.partnerUniqueId,
      authorizer_nsu: this.authorizerNsu,
      capture_nsu: this.captureNsu,
      authorizer_transaction_id: this.authorizerTransactionId,
      flows: this.stringToArray(this.flows)
    };
  }

  createPostDownload() {
    return {
      start: this.start ?? moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
      end: this.end ?? moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
      payment_method_type_ids: this.stringToArray(this.methods),
      card_brand_ids: this.stringToArray(this.brands),
      service_ids: this.stringToArray(this.services),
      payment_status_ids: this.stringToArray(this.statuses),
      installments: this.stringToArray(this.installments).length == 0 || this.stringToArray(this.installments).length == 2 ? null : this.installments == '1' ? true : false,
      min_amount: this.minAmount,
      max_amount: this.maxAmount,
      date_sort_asc: this.dateSort === 'asc',
      search_type: this.searchType,
      search_term: this.searchTerm,
      partner_unique_id: this.partnerUniqueId,
      authorizer_nsu: this.authorizerNsu,
      capture_nsu: this.captureNsu,
      authorizer_transaction_id: this.authorizerTransactionId,
      flows: this.stringToArray(this.flows),
    };
  }

  loadPeriod(): any {
    return {
      start: moment(this.start).startOf('day').toString(),
      end: moment(this.end).endOf('day').toString()
    };
  }

  loadFilter() {
    return {
      methodTypes: this.stringToArray(this.methods),
      cardBrands: this.stringToArray(this.brands).map(Number),
      services: this.stringToArray(this.services).map(Number),
      statuses: this.stringToArray(this.statuses),
      installments: this.stringToArray(this.installments).map(Number),
      amountRange: this.minAmount?.length || this.maxAmount?.length ? [this.minAmount, this.maxAmount] : [],
      hasFilter: this.methods?.length || this.brands?.length || this.services?.length || this.statuses?.length || this.installments?.length || this.minAmount?.length || this.maxAmount?.length || this.flows?.length,
      partnerUniqueId: this.searchType === 'partner_unique_id' ? this.searchTerm : this.partnerUniqueId,
      authorizerNsu: this.searchType === 'authorizer_nsu' ? this.searchTerm : this.authorizerNsu,
      captureNsu: this.searchType === 'capture_nsu' ? this.searchTerm : this.captureNsu,
      authorizerTransactionId: this.searchType === 'authorizer_transaction_id' ? this.searchTerm : this.authorizerTransactionId,
      flows: this.stringToArray(this.flows),
    };
  }

  loadSearch() {
    return {
      search_type: this.searchType,
      search_term: this.searchTerm
    };
  }

  arrayToString(array) {
    return array?.length ? array.join(',') : null;
  }

  stringToArray(array) {
    return array?.length ? array.split(',') : [];
  }
}
